var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTorrentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect846",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.277027,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.4742065,0.66765952 H 1.4614096 c -0.1465792,0 -0.2645834,0.11800417 -0.2645834,0.26458334 V 5.4177572 c 0,0.1465794 0.1180042,0.2645833 0.2645834,0.2645833 h 3.4271809 c 0.1465794,0 0.2645833,-0.1180039 0.2645833,-0.2645833 V 2.4871867 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2297",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 5.24551,2.527106 3.4289107,0.53750651 V 2.2377918 c -3e-7,0.1602801 0.1276773,0.2893142 0.2862725,0.2893142 z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.264583,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect33052",
    width: 5.0270839,
    height: 1.0748699,
    x: 0.66145819,
    y: 3.8364582,
    rx: 0.26458335,
    ry: 0.26458335
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.661458px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 1.232393,
    y: 4.6209478,
    id: "text8962"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan8960",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "0.661458px",
      fontFamily: "Speeday",
      InkscapeFontSpecification: "Speeday",
      fill: "#000000",
      strokeWidth: 0.264583
    },
    x: 1.232393,
    y: 4.6209478
  }, "TORRENT"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorrentIcon);
export default __webpack_public_path__ + "static/media/torrent-icon.44998ac451099651345e3b2030669dd3.svg";
export { ForwardRef as ReactComponent };